import { useTranslation } from 'react-i18next';
import SearchableSelect from '../searchableSelect/searchableSelect';
import { useMatterRequestTypeSelect } from './useMatterRequestTypeSelect';

interface MatterRequestTypeSelectProps {
  onOpenPicker: () => void;
  onClear: () => void;
}

/**
 * Its own component so the type list is only fetched where the field is rendered. It renders the
 * trigger button directly, which lookup siblings like `LookupClearButton` rely on.
 */
const MatterRequestTypeSelect = ({
  onOpenPicker,
  onClear,
}: Readonly<MatterRequestTypeSelectProps>) => {
  const { t } = useTranslation();
  const select = useMatterRequestTypeSelect();

  return (
    <SearchableSelect
      {...select}
      ariaLabel={t('matterRequest:type')}
      placeholder={t('matterRequest:selectType')}
      searchPlaceholder={t('matterRequest:searchMatterRequestTypes')}
      onSearchIconClick={onOpenPicker}
      onClear={onClear}
      data-field="matterRequestType"
      data-testid="select-matter-request-type-button"
    />
  );
};

export default MatterRequestTypeSelect;
